import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { switchMap, catchError, tap } from 'rxjs/operators';
import {
    EMissionActions,
    SaveMission,
    SaveMissionSuccess,
    UpdateMission
} from '../actions/mission.actions';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { select, Store } from '@ngrx/store';
import { MsisdnMissionService } from '../../services/msisdn-mission.service';
import { AbstractEffects } from '../../abstract.effects';
import { UpdateSelectedProcedure } from '../actions/selected-procedure.actions';
import { LineInterfaceState } from '../../../lines/store/state/line.state';
import { GetMsisdnProcedures } from '../../../lines/store/actions/msisdn-procedures.actions';
import { MsisdnListInterfaceState } from '../../../lines/store/state/msisdn-list.state';
import { MfaInterface } from '../../models/mfa.interface';
import { UpdateMfaVisibility } from '../actions/mfa.actions';

@Injectable()
export class MissionEffects extends AbstractEffects {

  constructor(
    private msisdnMissionService: MsisdnMissionService,
    private actions: Actions,
    public override store: Store<any>
  ) {
    super(store);
  }

  procedureCode: string;
  payload: any;
  mfa: MfaInterface|null = null;

    updateMission = createEffect(() => this.actions.pipe(
        ofType<UpdateMission>(EMissionActions.UpdateMission),
        tap(params => {
            this.payload = params.payload;
            this.procedureCode = params.procedureCode;
            this.mfa = params.mfa;
        }),
        switchMap(() => this.msisdnMissionService.update(this.payload, this.procedureCode, this.mfa)),
        switchMap((response: any) => of(new SaveMissionSuccess(response))),
        tap( () => {
            if (this.mfa) {
                this.mfa.visibility = false;
                this.store.dispatch(new UpdateMfaVisibility(this.mfa));
            }
            this.store.pipe(select(ConstsHelper.REDUCER_LINE)).subscribe((response: LineInterfaceState) => {
                if (response.line.phoneNumber === this.payload.phoneNumber) {
                    this.store.dispatch(new GetMsisdnProcedures(response.line));
                }
            });
            this.store.dispatch(new UpdateSelectedProcedure(''));
            this.DisplayMessage(this.procedureCode, 200, new UpdateSelectedProcedure(''), this.payload);
        }),
        catchError((error) => {
            if (this.mfa && error.error.error_message && error.error.error_message.includes('invalid_code')) {
                this.mfa.errorMessage = ConstsHelper.ERROR_MESSAGE_MFA_INVALID_CODE;
                this.store.dispatch(new UpdateMfaVisibility(this.mfa));
            } else if (this.mfa && error.error.error_message && error.error.error_message.includes('blocked')) {
                this.mfa.errorMessage = ConstsHelper.ERROR_MESSAGE_MFA_BLOCKED;
                this.store.dispatch(new UpdateMfaVisibility(this.mfa));
            } else {
                this.DisplayMessage('error_with_retry', 400);
            }
            return throwError(error);
        })
    ));

    saveMission = createEffect(() => this.actions.pipe(
        ofType<SaveMission>(EMissionActions.SaveMission),
        tap(params => {
            this.payload = params.payload;
            this.procedureCode = params.procedureCode;
            this.mfa = params.mfa;
        }),
        switchMap(() => this.msisdnMissionService.save(this.payload, this.procedureCode, this.mfa)),
        switchMap((response: any) => of(new SaveMissionSuccess(response))),
        tap( () => {
            if (this.mfa) {
                this.mfa.visibility = false;
                this.store.dispatch(new UpdateMfaVisibility(this.mfa));
            }
            this.updateSate(this.procedureCode, this.payload);
            this.store.dispatch(new UpdateSelectedProcedure(''));
            this.DisplayMessage(this.procedureCode, 200, new UpdateSelectedProcedure(''), this.payload);
        }),
        catchError((error) => {
            if (this.mfa && error.error.error_message && error.error.error_message.includes('invalid_code')) {
                this.mfa.errorMessage = ConstsHelper.ERROR_MESSAGE_MFA_INVALID_CODE;
                this.store.dispatch(new UpdateMfaVisibility(this.mfa));
            } else if (this.mfa && error.error.error_message && error.error.error_message.includes('blocked')) {
                this.mfa.errorMessage = ConstsHelper.ERROR_MESSAGE_MFA_BLOCKED;
                this.store.dispatch(new UpdateMfaVisibility(this.mfa));
            } else if (error.error.error_message && error.error.error_message.includes('error_to_generate_esim')) {
                this.DisplayMessage('error_to_generate_esim', 400);
            } else {
                this.DisplayMessage('error_with_retry', 400);
            }
            return throwError(error);
        })
    ));

    private updateSate(procedureCode: string, object: any) {
        if (procedureCode === ConstsHelper.PROCEDURE_IDENTIFY_LINE) {
            this.store.pipe(select(ConstsHelper.REDUCER_MSISDN_LIST)).subscribe((response: MsisdnListInterfaceState) => {
                for (const customerLine of response.list) {
                    if (customerLine.phoneNumber === object.phoneNumber) {
                        customerLine.titular = object.newName;
                        break;
                    }
                }
            });
            // update description selected line
            this.store.pipe(select(ConstsHelper.REDUCER_LINE)).subscribe((response: LineInterfaceState) => {
                if (response.line.phoneNumber === object.phoneNumber) {
                    if (procedureCode === ConstsHelper.PROCEDURE_IDENTIFY_LINE) {
                        response.line.description = object.newName;
                    }
                    this.store.dispatch(new GetMsisdnProcedures(response.line));
                }
            });
        } else {
            this.store.pipe(select(ConstsHelper.REDUCER_LINE)).subscribe((response: LineInterfaceState) => {
                if (response.line.phoneNumber === object.phoneNumber) {
                    this.store.dispatch(new GetMsisdnProcedures(response.line));
                }
            });
        }
    }
}
